<script setup lang="ts">
import UAppBar from '@d/app/components/layout/UAppBar.vue'
import { useDeviceBreakpoint } from '@d/app/composables/useDeviceBreakpoint'
import { provideStateScope } from '@d/app/helper/shortcut'
import { mdiArrowLeftThick } from '@mdi/js'
import '../style/main.scss'

// const layoutData = defineLayoutController('default', { rightDrawer: false })

// interface DrawerTab {
//   title: string
//   icon: string
//   id: string
// }

// const drawerTabs = computed(() => ([
//   { title: t('')}
// ] as DrawerTab[]))

// const usermanager = inject(UserManagerSymbol)
const breakpoint = useDeviceBreakpoint()

const mobile = computed(() => breakpoint.smaller('tablet').value)

const route = useRoute('client-me')

function close(): void {
  navigateTo({ name: 'client', params: { client: route.params.client } })
}

provideStateScope()
</script>

<template>
  <v-layout :class="{ 'is-mobile': mobile }">
    <!-- <v-system-bar color="deep-purple darken-3"></v-system-bar> -->

    <UAppBar>
      <template #left>
        <v-btn :icon="mdiArrowLeftThick" class="mx-2" @click="close" />
      </template>
    </UAppBar>

    <v-main style="display: flex;flex-direction: column; height: 100%">
      <div style="display: flex; flex-direction: column; flex-grow: 1; overflow: auto">
        <Suspense>
          <slot />
          <template #fallback>
            <v-skeleton-loader type="article" />
          </template>
        </Suspense>
      </div>
    </v-main>
  </v-layout>
</template>

<style scoped>
.link{
  text-transform: none !important;
}
</style>
